export const validationMsg = {
  required: "This field is required field",
  invalidEmail: "Enter valid email",
  empty: "This field cannot be empty",
  minLength: "This field cannot be less than ",
  maxLength: "This field cannot be more than ",
  pattern: "This field format is not correct",
  min: "This field cannot be less than ",
  max: "This field cannot be more than ",
  invalidDate: "Invalid Expiration Date",
  dateInTheFuture: "Invalid Date (Must be in the future)",
  notInPattern: "This field cannot be numbers only",
  requiredNumber: "This field must be number",
  textOnly: "This field can't contain space or numbers and must contain letters only",
  lessThanOtherField: "This field must be a number less than or equal ",
  moreThanOtherField: "This field must be a number more than ",
}

export const validationMsgAr = {
  required: "مطلوب",
  invalidEmail: "أدخل بريدًا إلكترونيًا صالحًا",
  empty: "لا يمكن ان يكون فارغا",
  minLength: "لا يمكن أن يكون أقل من ",
  maxLength: "لا يمكن أن يكون أكثر من ",
  pattern: "تنسيق الـغير صحيح",
  min: "لا يمكن أن يكون أقل من ",
  max: "لا يمكن أن يكون أكثر من ",
  invalidDate: "تاريخ انتهاء صلاحية غير صالح",
  dateInTheFuture: "التاريخ غير صالح (يجب أن يكون في المستقبل)",
  notInPattern: "لا يمكن أن تكون أرقامًا فقط",
  requiredNumber: "يجب أن يكون رقمًا",
  textOnly: "لا يمكن أن تحتوي على مسافة أو أرقام و يجب أن يحتوي على أحرف فقط",
  lessThanOtherField: "يجب أن يكون رقمًا أصغر من أو يساوي ",
  moreThanOtherField: "يجب أن يكون رقمًا أكبر من ",
}
